// custom-logo-mats products (10 items)
export const productsCustomLogoMats = [
  {
    id: 4,
    slug: "portico-nop-customs",
    name: "Portico Nop",
    variant: "Custom Logo Mats",
    type: "Custom Logo Mats",
    category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",    productSheetPdf: "/Assets/pdf/portico-nop-customs/PS_ISS_PorticoNop_CLM.pdf",
    techSpecsPdf: "/Assets/pdf/portico-nop-customs/PS_TechSpecs_PorticoNop_CLM.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
    colorCount: 38,
    sizeFormat: "Custom Sizes",
    zones: [1, 2, 3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["neutral", "blue", "earth-tones", "green", "red", "charcoal", "grey", "tan", "brown", "multi-color"],
      patterns: ["berber", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/portico-nop-CLM/PN-CLM_thumbnail.jpg",
    heroImage: "/Assets/images/products/portico-nop-clm/portico_hotel_inlaid.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use" },
      { src: "/Assets/icons/attributes/glp-carpet-green.svg", alt: "Green Label Plus Certified" }
    ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.47 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat with edging, or Glue-down recess well",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
    keyFeatures: [
      "Versatility in wet and high-traffic areas",
      "Provides extra-high dirt absorption",
      "Logo or plain matting options in a wide variety of colors"
    ],
    gallery: [
      "/Assets/images/products/portico-nop-CLM/PN_CLM-hero-img-(2).jpg",
      "/Assets/images/products/portico-nop-clm/portico_mondrian_closeup.jpg",
      "/Assets/images/products/portico-nop-clm/portico_mondrian_cabana.jpg",
      "/Assets/images/products/portico-nop-clm/portico_crest_entrance.jpg",
      "/Assets/images/products/portico-nop-clm/portico_pacesferry_vet.jpg",
      "/Assets/images/products/portico-nop-CLM/PN_CLM-hero-img-(2).jpg",
      "/Assets/images/new-product-imgs/Portico-Nop-CLM/portico-nop_clm_02.jpg",
      "/Assets/images/new-product-imgs/Portico-Nop-CLM/portico-nop_clm_03.jpg",
      "/Assets/images/new-product-imgs/Portico-Nop-CLM/portico-nop_clm_05.jpeg",
      "/Assets/images/products/portico-nop-clm/portico_laurelgolf.jpg",
      "/Assets/images/products/portico-nop-clm/portico_gypsea_2.jpg",
      "/Assets/images/products/portico-nop-clm/portico_27217311.jpeg",
      "/Assets/images/products/portico-nop-clm/portico_rochestergolfclub.jpg"
    ],
    inheritSwatchesFrom: "portico-nop-roll-goods",
    swatches: [],
    isPlaceholder: false,
    description: "Portico Nop helps you create clean, professional entrances that perform in any weather. When your space sees heavy foot traffic and changing conditions, you need matting that looks good and keeps working day after day. That's why Portico Nop is our most popular all-weather solution. With timeless style, exceptional flexibility, and reliable performance, it helps you protect your floors and make a strong first impression, without constant maintenance worries. Available in warm neutrals, modern brights, and classic standard colors, Portico Nop fits seamlessly into any environment. Made from 100% ASOTA® polypropylene fibers, this non-woven carpet is UV stable, stain resistant, highly durable, and built to bounce back under pressure.",
    features: [
      "Versatility in wet and high-traffic areas",
      "Provides extra-high dirt absorption",
      "Logo or plain matting options in a wide variety of colors"
    ],
    specifications: {
      fiberContent: "100% Solution-dyed UV stabilized ASOTA® polypropylene",
      construction: "Non-woven/needlepunched",
      details: "Corners patched for enforcement"
    }
  },
  {
    id: 18,
    slug: "2n1-custom-logo-mat",
    name: "2-N-1 Custom",
    variant: "Custom Logo Mats",
    type: "Custom Logo Mat",
    category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",    productSheetPdf: "/Assets/pdf/2n1-custom-logo-mat/PS_ISS_Two-N-One_CLM.pdf",
    techSpecsPdf: "/Assets/pdf/2n1-custom-logo-mat/PS_TechSpecs_2N1_CLM.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
    colorCount: 0,
    sizeFormat: "Custom",
    zones: [1, 2, 3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["multi-color", "black"],
      patterns: ["berber", "ribbed", "textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/2n1-clm/2n1_clm_thumbnail.jpg",
    heroImage: "/Assets/images/products/2n1-clm/hero_img.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use" }
    ],
    comparisonSpecs: {
      material: "PVC (Ribbed Grid) + ASOTA® polypropylene",
      construction: "Hybrid",
      backing: "Flexible PVC + Premium Composite Rubber",
      thickness: "0.47 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat with edging, or Glue-down recess well",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
    keyFeatures: [
      "Dual-action cleaning",
      "Built to last with industry-leading assembly process",
      "Fully customizable for semi-permanent wall-to-wall installation"
    ],
    gallery: [
      "/Assets/images/products/2n1-clm/2n1_tysons_corner.jpg",
      "/Assets/images/products/2n1-clm/2n1_-(4).jpg",
      "/Assets/images/products/2n1-clm/2n1_nologo.jpg",
      "/Assets/images/products/2n1-clm/2n1_nylife.jpg"
    ],
    swatches: [],
    isPlaceholder: false,
    description: [
      "If you manage a high-traffic entrance, you need a flooring system that keeps dirt out without creating hazards for heels, wheels, or carts. The problem is that most entry mats either trap debris poorly or create accessibility issues.",
      "This high-performance system combines a serrated grid entry surface with durable all-weather walk-off carpet, so your building stays cleaner, safer, and easier to maintain."
    ],
    features: [
      "Dual-action cleaning",
      "Built to last with industry-leading assembly process",
      "Fully customizable for semi-permanent wall-to-wall installation"
    ],
    specifications: {
      gridFunction: "Serrated grid scrapes & traps dirt and debris",
      carpetFunction: "Walk-off carpet removes remaining dirt & excess moisture",
      trafficRating: "Medium to high traffic environments"
    }
  },
  {
    id: 27,
    slug: "kensington-custom-logo",
    name: "Kensington Custom",
    variant: "Custom Logo Mats",
    type: "Custom Logo Mat",
    category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",    productSheetPdf: "/Assets/pdf/kensington-custom-logo/PS_ISS_Kensington_CLM.pdf",
    techSpecsPdf: "/Assets/pdf/kensington-custom-logo/PS_TechSpecs_Kensington_CLM.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
    colorCount: 0,
    sizeFormat: "Custom",
    zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "blue", "brown", "charcoal", "red"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/kensington-clm/kensington_CLM_thumbnail.jpg",
    heroImage: "/Assets/images/products/kensington-clm/kensington_CLM_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "PA6 Space Dyed Nylon",
      construction: "Tufted",
      backing: "Premium Composite Rubber",
      thickness: "0.375 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat with edging, or Glue-down recess well",
      recommendedZone: "Zones 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
    keyFeatures: [
      "Beautiful, striated design available in five colors",
      "Tufted 30 oz nylon provides superior performance",
      "Available in carpet tile & sheet/roll goods"
    ],
    gallery: [
      "/Assets/images/products/kensington-clm/kensington_CLM_hero.jpg",
      "/Assets/images/products/kensington-clm/kensington_CLM_lobby.jpg",
      "/Assets/images/products/kensington-clm/kensington_CLM_-(1).jpg",
      "/Assets/images/products/kensington-clm/kensington_CLM_entrance.jpg",
      "/Assets/images/products/kensington-clm/kensington_CLM_windsor.jpg",
      "/Assets/images/products/kensington-clm/kensington_CLM_-(3).jpg",
      "/Assets/images/products/kensington-clm/kensington_CLM_-(4).jpg"
    ],
    inheritSwatchesFrom: "kensington-rolls-rg",
    swatches: [],
    isPlaceholder: false,
    description: [
      "If you want to create a commercial space that feels both comfortable and stylish, you need flooring that looks beautiful and performs under pressure. The problem is that many flooring options either sacrifice design for durability, or wear down quickly in high-traffic environments.",
      "Kensington Premium Sheet and Roll Goods give you the best of both worlds. Designed to elevate your space while standing up to heavy traffic, the Kensington collection helps you create environments that stay attractive, functional, and inviting for years to come."
    ],
    features: [
      "Premium sheet and roll goods",
      "Durable construction for high-traffic commercial spaces",
      "Nature-inspired striae pattern for subtle texture"
    ],
    specifications: {
      type: "Premium sheet and roll goods",
      pattern: "Nature-inspired striae pattern",
      aesthetic: "Warm, modern aesthetic"
    }
  },
  {
    id: 30,
    slug: "natural-coco-custom",
    name: "Natural Coco Custom",
    variant: "Custom Logo Mats",
    type: "Custom Logo Mat",
    category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",    productSheetPdf: "/Assets/pdf/natural-coco-custom/PS_ISS_NATCoco_CLM.pdf",
    techSpecsPdf: "/Assets/pdf/natural-coco-custom/PS_TechSpecs_NatCoco_CLM.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
    colorCount: 0,
    sizeFormat: "Custom",
    zones: [2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "black", "blue", "green", "red", "brown"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
    image: "/Assets/images/products/natural-coco/Nat-Coco_FF_thumbnail.jpg",
    heroImage: "/Assets/images/products/natural-coco/Nat-Coco_FF_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "Natural Coconut Fibers",
      construction: "Fusion Bonded",
      backing: "Vinyl",
      thickness: "0.625 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat with edging, or Glue-down recess well",
      recommendedZone: "Zones 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
    keyFeatures: [
      "Made with natural coconut/coir fibers",
      "Provides an unparalleled premium look",
      "Natural look & feel for indoor applications"
    ],
    gallery: [
      "/Assets/images/products/natural-coco/Nat-Coco_FF_-(1).jpg",
      "/Assets/images/products/natural-coco/NatCoco_CLM_entrance.jpg",
      "/Assets/images/products/natural-coco/NatCoco_Bank.png",
      "/Assets/images/products/natural-coco/NatCoco_LetterT.jpg",
      "/Assets/images/products/natural-coco/NatCoco_Plain.jpg",
      "/Assets/images/products/natural-coco/NatCoco_Saugatuck.jpg"
    ],
    inheritSwatchesFrom: "natural-coco-rg",
    swatches: [],
    isPlaceholder: false,
    description: [
      "If you want your entryway to make a strong first impression, you need a mat that reflects your values while keeping your space clean and professional. The problem is that many entry mats look synthetic or generic.",
      "Natural Coco is a unique, natural fiber mat designed specifically for recessed wells and entryways. Made from durable coconut fibers, it helps you create a warm, sustainable first impression while effectively capturing dirt at the door."
    ],
    features: [
      "Premium sheet & roll goods",
      "Durable construction non-Directional Smooth/Velour",
      "Nature-inspired coir fibers"
    ],
    specifications: {
      material: "Natural coconut/coir fibers",
      type: "Premium sheet & roll goods"
    }
  },
  {
    id: 31,
    slug: "pinnacle-hd-custom",
    name: "Pinnacle H.D. Custom",
    variant: "Custom Logo Mats",
    type: "Custom Logo Mat",
    category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",    productSheetPdf: "/Assets/pdf/pinnacle-hd-custom/PS_ISS_PinnacleHD_CLM.pdf",
    techSpecsPdf: "/Assets/pdf/pinnacle/PS_TSS_Pinnacle-HD.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
    colorCount: 10,
    sizeFormat: "Custom",
    zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "blue", "red", "green", "brown", "black"],
      patterns: ["ribbed", "textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/pinnacle/placeholder_1.jpg",
    heroImage: "/Assets/images/products/pinnacle/pinnacleHD_hero.jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" },
      { src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use" }
    ],
    comparisonSpecs: {
      material: "Solid Polyvinyl Chloride",
      construction: "Molded Ribbed Surface",
      backing: "Vinyl Screen/mesh",
      thickness: "0.25 inch",
      trafficRating: "High",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat with edging, or Glue-down recess well",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
    keyFeatures: [
      "Fully ADA Compliant",
      "Extremely strong & tough",
      "Aggressive scraping"
    ],
    gallery: [
      "/Assets/images/products/pinnacle/Pinnacle_CommunityProtector.jpg",
      "/Assets/images/products/pinnacle/Pinnacle_Restaurant.jpg",
      "/Assets/images/products/pinnacle/pinnacleHD_hero.jpg",
      "/Assets/images/products/pinnacle/pinnacle_closeup.jpg",
      "/Assets/images/products/pinnacle/Pinnacle_Baseball.jpg",
      "/Assets/images/products/pinnacle/pinnacle_closeup_holes.jpg",
      "/Assets/images/products/pinnacle/Pinnacle_drainage_edging.jpg"
    ],
    swatches: [
      { name: "Beige", image: "/Assets/images/products/pinnacle/Swatches/Beige.jpg" },
      { name: "Black", image: "/Assets/images/products/pinnacle/Swatches/Black.jpg" },
      { name: "Blue", image: "/Assets/images/products/pinnacle/Swatches/Blue.jpg" },
      { name: "Brown", image: "/Assets/images/products/pinnacle/Swatches/Brown.jpg" },
      { name: "Green", image: "/Assets/images/products/pinnacle/Swatches/Green.jpg" },
      { name: "Grey", image: "/Assets/images/products/pinnacle/Swatches/Grey.jpg" },
      { name: "Light Blue", image: "/Assets/images/products/pinnacle/Swatches/Light-Blue.jpg" },
      { name: "Red", image: "/Assets/images/products/pinnacle/Swatches/Red.jpg" },
      { name: "White", image: "/Assets/images/products/pinnacle/Swatches/White.jpg" },
      { name: "Yellow", image: "/Assets/images/products/pinnacle/Swatches/Yellow.jpg" }
    ],
    isPlaceholder: false,
    description: [
      "If you manage a high-traffic entrance in a demanding climate, you need a mat that protects your space and maintains your brand image, no matter how harsh the conditions. The problem is that many entrance mats wear down quickly, fade over time, or lose their visual impact.",
      "Our PVC vinyl entrance mats are built to perform in extreme climates and heavy-traffic environments. Available in a wide range of colors, each design is precision cut and inlaid—not just printed on—so your image lasts as long as the mat itself."
    ],
    features: [
      "UV Resistant",
      "Perfect solution for all-weather environments",
      "Precision cut and inlaid design"
    ],
    specifications: {
      compliance: "Fully ADA Compliant",
      durability: "UV Resistant, all-weather performance"
    }
  },
  {
    id: 32,
    slug: "spectra-print-hd",
    name: "Spectra Print H.D.",
    variant: "Custom Logo Mats",
    type: "Custom Logo Mat",
    category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",    productSheetPdf: "/Assets/pdf/spectra-print-hd/PS_ISS_SpectraPrintHD.pdf",
    techSpecsPdf: "/Assets/pdf/spectra-print-hd/PS_TSS_SpectraPrint-HD.pdf",
    zoneIcon: "/Assets/icons/zones/Zones_3_icon.svg",
    colorCount: 0,
    sizeFormat: "Custom",
    zones: [3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["multi-color"],
      patterns: ["textured", "modern"],
      budgetLevels: ["mid-range", "premium"],
    image: "/Assets/images/products/spectra-print/SpectraPrint_-(1).jpg",
    heroImage: "/Assets/images/products/spectra-print/SpectraPrint_-(1).jpg",
    attributeIcons: [
      { src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use" }
    ],
    comparisonSpecs: {
      material: "PET Fiber",
      construction: "Non-woven Delour",
      backing: "Safety-Track",
      thickness: "0.325 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat, with or without edging",
      recommendedZone: "Zone 3",
      bestUseCase: "Inlay matting, entryways"
    },
    keyFeatures: [
      "MADE in the USA",
      "Infinite Design Possibilities",
      "No minimums"
    ],
    gallery: [
      "/Assets/images/products/spectra-print/SpectraPrint_-(1).jpg",
      "/Assets/images/products/spectra-print/SpectraPrint_-(2).jpg",
      "/Assets/images/products/spectra-print/Daycare_Welcome.jpg",
      "/Assets/images/products/spectra-print/SpectraPrint_-(4).jpg",
      "/Assets/images/products/spectra-print/Spectra_Basketball.jpg",
      "/Assets/images/products/spectra-print/Spectra_LobbyHotel.jpg"
    ],
    swatches: [],
    isPlaceholder: false,
    description: [
      "If you want your entrance to make a powerful first impression, you need branding that stands out with clarity and precision. The problem is that many custom mats produce dull colors, low-resolution graphics, or designs that fail to capture the true impact of your brand.",
      "Spectra Print HD brings your brand to life with next-generation custom matting technology. Engineered with an extraordinary 2800 DPI resolution, it delivers photographic-quality graphics and exceptional color accuracy."
    ],
    features: [
      "Premium Rubber Backing provides superior grip and dimensional stability",
      "Available in custom shapes and sizes",
      "Indoor use only"
    ],
    specifications: {
      resolution: "2800 DPI photographic-quality graphics",
      backing: "Premium Rubber Backing",
      origin: "Made in the USA"
    }
  },
  {
      id: 36,
      slug: "astoria-nop-clm",
      name: "Astoria Nop",
      variant: "Custom Logo Mats",
      type: "Custom Logo Mats",
      category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",
      productSheetPdf: "/Assets/pdf/astoria-nop-clm/PS_ISS_AstoriaNop_CLM.pdf",
    techSpecsPdf: "/Assets/pdf/astoria-nop-clm/PS_TechSpecs_AstoriaNop_CLM.pdf",
      saleSheetPdf: "/Assets/pdf/astoria-nop-clm/PS_ISS_AstoriaNop_CLM.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 1,
      sizeFormat: "Custom",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["grey", "charcoal", "blue", "earth-tones"],
      patterns: ["berber", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/astoria-nop-clm/placeholder_thumbnail.jpg",
      heroImage: "/Assets/images/products/astoria-nop-clm/astoria-nop-clm_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"}
      ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.375 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat with edging, or Glue-down recess well",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
      keyFeatures: ["High-performance needle-punched construction", "Solution-dyed, UV stabilized ASOTA\u00ae polypropylene fiber", "Available in sheet/roll goods & custom/logo matting"],
      gallery: ["/Assets/images/products/astoria-nop-clm/astoria-nop-clm_hero.jpg", "/Assets/images/products/astoria-nop-clm/astoria-nop-clm_gallery_1.jpg", "/Assets/images/products/astoria-nop-clm/astoria-nop-clm_gallery_2.jpg", "/Assets/images/products/astoria-nop-clm/astoria-nop-clm_gallery_3.jpg"],
      inheritSwatchesFrom: "astoria-nop-rg",
      swatches: [],
      isPlaceholder: false,
      description: "When facilities want to reinforce their brand while maintaining clean, professional spaces, Astoria Custom Logo Mats provide a durable and practical solution. Built with dense 37 oz. fibers, the classic berber-style surface resists crushing while capturing dirt and moisture from daily traffic. The solution-dyed, UV-stabilized ASOTA® polypropylene construction performs reliably in varying conditions, while the material can be custom cut without edge ravel—allowing logos and branding to stand out with long-lasting clarity. Designed for dependable performance, Astoria Logo Mats help turn everyday floor protection into a branded first impression.",
      features: ["High-performance needle-punched construction", "Solution-dyed, UV stabilized ASOTA\u00ae polypropylene fiber", "Available in sheet/roll goods & custom/logo matting"],
      specifications: {}
    },
  {
      id: 57,
      slug: "premier-nop-customs-clm",
      name: "Premier Nop - CUSTOMS",
      variant: "Custom Logo Mats",
      type: "Custom Logo Mats",
      category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",
      productSheetPdf: "/Assets/pdf/premier-nop-customs-clm/PS_ISS_PremierNop_CLM.pdf",
    techSpecsPdf: "/Assets/pdf/premier-nop-customs-clm/PS_TechSpecs_PremierNop_CLM.pdf",
      saleSheetPdf: "/Assets/pdf/premier-nop-customs-clm/PS_ISS_PremierNop_CLM.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 12,
      sizeFormat: "Custom",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["neutral", "grey", "blue", "earth-tones", "red"],
      patterns: ["berber", "modern"],
      budgetLevels: ["mid-range", "premium"],
      image: "/Assets/images/products/premier-nop-customs-clm/premier-nop-customs-clm_gallery_1.jpg",
      heroImage: "/Assets/images/products/premier-nop-customs-clm/premier-nop-customs-clm_gallery_1.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"}
      ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.47 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat with edging, or Glue-down recess well",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
      keyFeatures: ["44 oz. Needle-punched Contract Carpet", "A particularly effective and stylish entrance flooring"],
      gallery: ["/Assets/images/products/premier-nop-customs-clm/premiernop_bloomingdales.jpg", "/Assets/images/products/premier-nop-customs-clm/premier-nop-customs-clm_gallery_5.jpg", "/Assets/images/products/premier-nop-customs-clm/premiernop_CLM-5.jpg", "/Assets/images/products/premier-nop-customs-clm/premiernop_CLM-6.jpg", "/Assets/images/products/premier-nop-customs-clm/premiernop_CLM_210.jpg", "/Assets/images/products/premier-nop-customs-clm/premier-nop-customs-clm_gallery_1.jpg", "/Assets/images/products/premier-nop-customs-clm/premiernop_CLM-1.jpg", "/Assets/images/products/premier-nop-customs-clm/premiernop_CLM-2.jpg"],
      inheritSwatchesFrom: "premier-nop-tile-rg",
      swatches: [],
      isPlaceholder: false,
      description: "High-traffic areas constantly bring in sand, dirt, and moisture that can quickly damage surrounding floors. Premier Nop helps facilities control that challenge with a durable fiber-bond Berber construction designed to capture up to 80% of debris before it spreads through the building. The high-heel safe surface performs reliably in busy environments, while its strong dirt-trapping ability helps reduce maintenance and protect interior flooring. Practical and economical, Premier Nop delivers dependable performance where traffic never slows down.",
      features: ["44 oz. Needle-punched Contract Carpet", "A particularly effective and stylish entrance flooring"],
      specifications: {}
    },
  {
      id: 61,
      slug: "safe-tread-customs-clm",
      name: "Safe Tread - CUSTOMS",
      variant: "Custom Logo Mats",
      type: "Custom Logo Mats",
      category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",
      productSheetPdf: "/Assets/pdf/safe-tread-customs-clm/PS_ISS_SafeTread_CLM.pdf",
    techSpecsPdf: "/Assets/pdf/safetread-logo-mat/PS_TSS_SafeTread_CLM.pdf",
      saleSheetPdf: "/Assets/pdf/safe-tread-customs-clm/PS_ISS_SafeTread_CLM.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 1,
      sizeFormat: "Custom",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Grocery & Convenience Stores", "Retailers", "Hospitality Sector", "Mass Merchandiser", "Educational Institutions", "Financial Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores", "Fitness Centers & Gymnasiums"],
      colorTones: ["multi-color", "black"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/safe-tread-customs-clm/safetread_freshmart_thumbnail.jpg",
      heroImage: "/Assets/images/products/safe-tread-customs-clm/safe-tread-customs-clm_hero.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"}
      ],
    comparisonSpecs: {
      material: "Nitrile Rubber",
      construction: "Molded Raised Gripper Surface",
      backing: "rubber",
      thickness: "0.25 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat with edging, or Glue-down recess well",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
      keyFeatures: ["Lightweight design makes placing the mat when and where you need it a cinch Air", "One-piece molded construction makes for easy clean-up", "Scraping away excess dirt to add safety and minimizing maintenance costs"],
      gallery: ["/Assets/images/products/safe-tread-customs-clm/safe-tread-customs-clm_hero.jpg", "/Assets/images/products/safe-tread-customs-clm/safetread_grocery2.jpg", "/Assets/images/products/safe-tread-customs-clm/safetread_entrance.jpg", "/Assets/images/products/safe-tread-customs-clm/warehouse_safetread.jpg", "/Assets/images/products/safe-tread-customs-clm/safe-tread-customs-clm_gallery_4.jpg"],
      swatches: [],
      isPlaceholder: false,
      description: "In busy commercial spaces, controlling dirt and maintaining safe walking surfaces is essential. Safe Tread provides a durable rubber matting solution designed to actively scrape debris from footwear while helping reduce maintenance demands. Its molded nitrile rubber construction delivers long-lasting performance under heavy use, while the cleated surface works to remove dirt and snow before it spreads across surrounding floors. Lightweight yet tough, Safe Tread is easy to position where protection is needed and simple to clean, making it a practical choice for facilities that demand dependable floor safety.",
      features: ["Lightweight design makes placing the mat when and where you need it a cinch Air", "One-piece molded construction makes for easy clean-up", "Scraping away excess dirt to add safety and minimizing maintenance costs"],
      specifications: {}
    },
  {
      id: 65,
      slug: "synthetic-coco-customs-clm",
      name: "Synthetic Coco - CUSTOMS",
      variant: "Custom Logo Mats",
      type: "Custom Logo Mats",
      category: "Custom Logo Mats",

    categoryId: "custom-logo-mats",
      productSheetPdf: "/Assets/pdf/synthetic-coco-customs-clm/PS_ISS_SynCoco_CLM.pdf",
    techSpecsPdf: "/Assets/pdf/synthetic-coco-customs-clm/PS_TechSpecs_SynCoco_CLM.pdf",
      saleSheetPdf: "/Assets/pdf/synthetic-coco-customs-clm/PS_ISS_SynCoco_CLM.pdf",
      zoneIcon: "/Assets/icons/zones/Zones_123_icon.svg",
      colorCount: 3,
      sizeFormat: "Custom",
      zones: [1, 2, 3],
      industries: ["Corporate Offices", "Retailers", "Mass Merchandiser", "Educational Institutions", "Government", "Pharmacy & Drugstore", "Specialty Stores"],
      colorTones: ["earth-tones", "grey", "black"],
      patterns: ["textured", "modern"],
      budgetLevels: ["economy", "mid-range"],
      image: "/Assets/images/products/synthetic-coco-customs-clm/synthetic-coco-customs-clm_thumbnail.jpg",
      heroImage: "/Assets/images/products/synthetic-coco-customs-clm/gallery/SYNCOCO_W.jpg",
      attributeIcons: [
        {src: "/Assets/icons/attributes/indoor-yes.svg", alt: "Indoor Use"},
        {src: "/Assets/icons/attributes/outdoor-yes.svg", alt: "Outdoor Use"}
      ],
    comparisonSpecs: {
      material: "ASOTA® polypropylene fibers",
      construction: "Non-woven",
      backing: "Premium Composite Rubber",
      thickness: "0.625 inch",
      trafficRating: "Medium",
      slipResistance: "Yes",
      installationType: "Loose Lay Mat with edging, or Glue-down recess well",
      recommendedZone: "Zones 1, 2, 3",
      bestUseCase: "Inlay matting, entryways"
    },
      keyFeatures: ["100 % solution-dyed UV stabilized polypropylene fibers are stain and fade resistant", "Dries quickly when compared to natural cocoa mats"],
      gallery: ["/Assets/images/products/synthetic-coco-customs-clm/gallery/SYNCOCO_W.jpg", "/Assets/images/products/synthetic-coco-customs-clm/gallery/Entrance-Of-A-Modern-Hotel.jpg", "/Assets/images/products/synthetic-coco-customs-clm/gallery/IMG_0508.jpg", "/Assets/images/products/synthetic-coco-customs-clm/gallery/IMG_1114_002.jpg", "/Assets/images/products/synthetic-coco-customs-clm/gallery/202506_1.jpg"],
      inheritSwatchesFrom: "synthetic-coco-rolls-rg",
      swatches: [
        {name: "Black", image: "/Assets/images/products/synthetic-coco-customs-clm/swatches/SynCoco_Black.jpg"},
        {name: "Grey", image: "/Assets/images/products/synthetic-coco-customs-clm/swatches/SynCoco_Grey.jpg"}
      ],
      isPlaceholder: false,
      description: "When facilities want the natural look of coco with the impact of branded entrance matting, Synthetic Coco Logo Mats provide a durable solution. Designed with 100% solution-dyed, UV-stabilized polypropylene fibers, these mats deliver the appearance of natural coir without the shedding while resisting stains and fading. They dry quickly, perform reliably in medium- to high-traffic environments, and can be cut into custom logo shapes up to 12 feet. The result is a professional entrance that reinforces brand identity while maintaining a clean, eco-conscious appearance.",
      features: ["100 % solution-dyed UV stabilized polypropylene fibers are stain and fade resistant", "Dries quickly when compared to natural cocoa mats"],
      specifications: {}
    },
];
